import { useEffect, useState } from 'react';
import classNames from 'classnames';

const YMHelmet = props => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showHelmet, setShowHelmet] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsPlaying(true);
    }, 100);

    setTimeout(() => {
      setShowHelmet(true);
    }, 1);
  }, []);

  return (
    <div className="helmet-hero mb-200">
      <div
        className={classNames('helmet', {
          'helmet--animate': isPlaying
        })}
      >
        {showHelmet && (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xlinkHref="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1608 1608"
            xmlSpace="preserve"
          >
            <linearGradient
              id="SVGID_1_"
              gradientUnits="userSpaceOnUse"
              x1="735.5753"
              y1="766.3603"
              x2="735.5753"
              y2="960.4709"
            >
              <stop offset="0" style={{ stopColor: '#D3020D' }} />
              <stop offset="1" style={{ stopColor: '#5D5FFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_2_"
              gradientUnits="userSpaceOnUse"
              x1="872.4432"
              y1="960.4709"
              x2="872.4432"
              y2="766.3603"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_3_"
              gradientUnits="userSpaceOnUse"
              x1="702.0519"
              y1="833.4909"
              x2="905.9673"
              y2="833.4909"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_4_"
              gradientUnits="userSpaceOnUse"
              x1="723.5228"
              y1="1119.6318"
              x2="723.5228"
              y2="940.4709"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_5_"
              gradientUnits="userSpaceOnUse"
              x1="884.4941"
              y1="940.4709"
              x2="884.4941"
              y2="1119.6318"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_6_"
              gradientUnits="userSpaceOnUse"
              x1="912.3292"
              y1="1039.3453"
              x2="912.3292"
              y2="766.3603"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#D3020D' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_7_"
              gradientUnits="userSpaceOnUse"
              x1="695.6913"
              y1="766.3603"
              x2="695.6913"
              y2="1039.3453"
            >
              <stop offset="0" style={{ stopColor: '#FF5300' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_8_"
              gradientUnits="userSpaceOnUse"
              x1="632.5381"
              y1="1038.9222"
              x2="632.5381"
              y2="1119.6318"
            >
              <stop offset="0" style={{ stopColor: '#D3020D' }} />
              <stop offset="1" style={{ stopColor: '#5D5FFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_9_"
              gradientUnits="userSpaceOnUse"
              x1="975.48"
              y1="1119.6318"
              x2="975.48"
              y2="1038.9222"
            >
              <stop offset="0" style={{ stopColor: '#B12DFF' }} />
              <stop offset="1" style={{ stopColor: '#FF5300' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_10_"
              gradientUnits="userSpaceOnUse"
              x1="659.7941"
              y1="1058.9222"
              x2="659.7941"
              y2="901.0858"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_11_"
              gradientUnits="userSpaceOnUse"
              x1="900.4706"
              y1="980.004"
              x2="995.9802"
              y2="980.004"
            >
              <stop offset="0" style={{ stopColor: '#B12DFF' }} />
              <stop offset="1" style={{ stopColor: '#5D5FFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_12_"
              gradientUnits="userSpaceOnUse"
              x1="864.913"
              y1="1201.895"
              x2="864.913"
              y2="1060.91"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_13_"
              gradientUnits="userSpaceOnUse"
              x1="743.1526"
              y1="1060.91"
              x2="743.1526"
              y2="1201.895"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_14_"
              gradientUnits="userSpaceOnUse"
              x1="968.821"
              y1="786.3603"
              x2="968.821"
              y2="632.176"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_15_"
              gradientUnits="userSpaceOnUse"
              x1="794.0083"
              y1="619.1634"
              x2="1006.7639"
              y2="619.1634"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_16_"
              gradientUnits="userSpaceOnUse"
              x1="601.2182"
              y1="619.1634"
              x2="814.0083"
              y2="619.1634"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#D3020D' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_17_"
              gradientUnits="userSpaceOnUse"
              x1="639.1802"
              y1="632.176"
              x2="639.1802"
              y2="786.3603"
            >
              <stop offset="0" style={{ stopColor: '#B12DFF' }} />
              <stop offset="1" style={{ stopColor: '#5D5FFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_18_"
              gradientUnits="userSpaceOnUse"
              x1="569.6313"
              y1="502.839"
              x2="569.6313"
              y2="652.176"
            >
              <stop offset="0" style={{ stopColor: '#FF5300' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_19_"
              gradientUnits="userSpaceOnUse"
              x1="620.0482"
              y1="502.839"
              x2="620.0482"
              y2="628.1035"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_20_"
              gradientUnits="userSpaceOnUse"
              x1="758.0212"
              y1="628.1035"
              x2="758.0212"
              y2="406.105"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_21_"
              gradientUnits="userSpaceOnUse"
              x1="986.7817"
              y1="577.5075"
              x2="1089.9556"
              y2="577.5075"
            >
              <stop offset="0" style={{ stopColor: '#5D5FFF' }} />
              <stop offset="1" style={{ stopColor: '#B12DFF' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_22_"
              gradientUnits="userSpaceOnUse"
              x1="987.9518"
              y1="628.1035"
              x2="987.9518"
              y2="502.839"
            >
              <stop offset="0" style={{ stopColor: '#B12DFF' }} />
              <stop offset="1" style={{ stopColor: '#FF5300' }} />
            </linearGradient>

            <linearGradient
              id="SVGID_23_"
              gradientUnits="userSpaceOnUse"
              x1="849.9788"
              y1="406.105"
              x2="849.9788"
              y2="628.1035"
            >
              <stop offset="0" style={{ stopColor: '#D3020D' }} />
              <stop offset="1" style={{ stopColor: '#5D5FFF' }} />
            </linearGradient>
            <g
              strokeWidth="20"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
            >
              <line
                className="helmet__path"
                stroke="url(#SVGID_1_)"
                x1="804"
                y1="950.5"
                x2="667.1"
                y2="776.4"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_2_)"
                x1="804"
                y1="950.5"
                x2="940.9"
                y2="776.4"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_3_)"
                x1="712.1"
                y1="833.5"
                x2="896"
                y2="833.5"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_4_)"
                x1="804"
                y1="950.5"
                x2="643"
                y2="1109.6"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_5_)"
                x1="804"
                y1="950.5"
                x2="965"
                y2="1109.6"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_6_)"
                x1="940.9"
                y1="776.4"
                x2="883.8"
                y2="1029.3"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_7_)"
                x1="667.1"
                y1="776.4"
                x2="724.2"
                y2="1029.3"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_8_)"
                x1="622"
                y1="1048.9"
                x2="643"
                y2="1109.6"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_9_)"
                x1="986"
                y1="1048.9"
                x2="965"
                y2="1109.6"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_10_)"
                x1="622"
                y1="1048.9"
                x2="697.5"
                y2="911.1"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_11_)"
                x1="910.5"
                y1="911.1"
                x2="986"
                y2="1048.9"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_12_)"
                x1="804"
                y1="1191.9"
                x2="925.8"
                y2="1070.9"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_13_)"
                x1="804"
                y1="1191.9"
                x2="682.3"
                y2="1070.9"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_14_)"
                x1="940.9"
                y1="776.4"
                x2="996.8"
                y2="642.2"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_15_)"
                x1="996.8"
                y1="642.2"
                x2="804"
                y2="596.2"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_16_)"
                x1="804"
                y1="596.2"
                x2="611.2"
                y2="642.2"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_17_)"
                x1="611.2"
                y1="642.2"
                x2="667.1"
                y2="776.4"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_18_)"
                x1="611.2"
                y1="642.2"
                x2="528"
                y2="512.8"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_19_)"
                x1="528"
                y1="512.8"
                x2="712.1"
                y2="618.1"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_20_)"
                x1="712.1"
                y1="618.1"
                x2="804"
                y2="416.1"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_21_)"
                x1="996.8"
                y1="642.2"
                x2="1080"
                y2="512.8"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_22_)"
                x1="1080"
                y1="512.8"
                x2="895.9"
                y2="618.1"
              />
              <line
                className="helmet__path"
                stroke="url(#SVGID_23_)"
                x1="895.9"
                y1="618.1"
                x2="804"
                y2="416.1"
              />
            </g>
          </svg>
        )}
      </div>
    </div>
  );
};

export default YMHelmet;
